// ═══════════════════════════════════════════════════════════════════
//  modules/documents/ComptesRendusModule.js
//  ComptesRendusModule
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { CrudHeader } from "../../composants/CrudHeader";
import { CrudModal } from "../../composants/CrudModal";
import { DataTable } from "../../composants/DataTable";
import { useCrud } from "../../socle/hooks";
import { THEME } from "../../socle/theme";

// ═══════════════ 5) COMPTES-RENDUS ═══════════════
export function ComptesRendusModule({ token, onBack }) {
  const { items, loading, create, update, remove } = useCrud(token, "/api/documents/comptes-rendus");
  const [edit,setEdit]=useState(undefined);
  const fields=[
    {key:"titre",label:"Titre",full:true,placeholder:"Réunion lore #3"},
    {key:"date_reunion",label:"Date",type:"date"},
    {key:"participants",label:"Participants",placeholder:"Gaëlle, Brice…"},
    {key:"decisions",label:"Décisions",full:true,type:"textarea"},
  ];
  const cols=[
    {key:"titre",label:"Titre",width:"1fr",render:(r)=><span style={{fontWeight:600}}>{r.titre}</span>},
    {key:"date_reunion",label:"Date",width:"120px",render:(r)=>r.date_reunion?r.date_reunion.slice(0,10):"—"},
    {key:"participants",label:"Participants",width:"1fr",render:(r)=><span style={{color:THEME.textMuted}}>{r.participants||"—"}</span>},
  ];
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <CrudHeader onBack={onBack} title="📝 Comptes-rendus" onAdd={()=>setEdit(null)} addLabel="+ Nouveau CR" />
      {loading ? <div style={{color:THEME.textMuted,padding:20}}>Chargement…</div> :
        <DataTable columns={cols} rows={items} onEdit={setEdit} onDelete={(id)=>{if(window.confirm("Supprimer ce compte-rendu ?"))remove(id);}} empty="Aucun compte-rendu." />}
      {edit!==undefined && <CrudModal title={edit?"Éditer le CR":"Nouveau compte-rendu"} fields={fields} initial={edit} onClose={()=>setEdit(undefined)} onSave={async(b)=>{ edit?await update(edit.id,b):await create(b); setEdit(undefined); }} />}
    </div>
  );
}
